import { lazy } from 'react'

export const SubscriptionsGoogleVariant1 = lazy(
  () => import('./SubscriptionsGoogleVariant1'),
)
